export default "__VITE_ASSET__DGVWxTHQ__"